import { render, staticRenderFns } from "./AddKubernetesSupportedVersion.vue?vue&type=template&id=a2e96226&scoped=true&"
import script from "./AddKubernetesSupportedVersion.vue?vue&type=script&lang=js&"
export * from "./AddKubernetesSupportedVersion.vue?vue&type=script&lang=js&"
import style0 from "./AddKubernetesSupportedVersion.vue?vue&type=style&index=0&id=a2e96226&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2e96226",
  null
  
)

export default component.exports